module.exports = __webpack_public_path__ + "img/kim-playful.def935d9.svg";